import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import {
	SECTION_ACCESS_CONTROL,
	SECTION_ADVANCED_ANALYSIS,
	SECTION_ADVANCED_FEATURES,
	SECTION_COLLABORATION,
	SECTION_CORE_FEATURES,
	SECTION_INTEGRATIONS,
	SECTION_MONITORING_SETTINGS,
	SECTION_SERVICES,
} from '~/model/benefits';



const messages = defineMessages({
	[SECTION_ACCESS_CONTROL]: {
		auditLog: {
			id: 'ui.planBenefits.section.accessControl.benefits.auditLog',
		},
		enforce2FA: {
			id: 'ui.planBenefits.section.accessControl.benefits.enforce2FA',
		},
		organizationAdminRole: {
			id: 'ui.planBenefits.section.accessControl.benefits.organizationAdminRole',
		},
		restrictEmailDomains: {
			id: 'ui.planBenefits.section.accessControl.benefits.restrictEmailDomains',
		},
	},
	[SECTION_ADVANCED_ANALYSIS]: {
		httpBodySnapshot: {
			id: 'ui.planBenefits.section.advancedAnalysis.benefits.httpBodySnapshot',
		},
		httpHeaderSnapshot: {
			id: 'ui.planBenefits.section.advancedAnalysis.benefits.httpHeaderSnapshot',
		},
		logFileAnalysis: {
			id: 'ui.planBenefits.section.advancedAnalysis.benefits.logFileAnalysis',
		},
		logFileExplorer: {
			id: 'ui.planBenefits.section.advancedAnalysis.benefits.logFileExplorer',
		},
	},
	[SECTION_ADVANCED_FEATURES]: {
		alertsForCustomElements: {
			id: 'ui.planBenefits.section.advancedFeatures.benefits.alertsForCustomElements',
		},
		coreWebVitalsMonitoring: {
			id: 'ui.planBenefits.section.advancedFeatures.benefits.coreWebVitalsMonitoring',
		},
		customElementExtraction: {
			id: 'ui.planBenefits.section.advancedFeatures.benefits.customElementExtraction',
		},
		dataRetention: {
			id: 'ui.planBenefits.section.advancedFeatures.benefits.dataRetention',
		},
		jsRendering: {
			id: 'ui.planBenefits.section.advancedFeatures.benefits.jsRendering',
		},
		realTimeIndexNow: {
			id: 'ui.planBenefits.section.advancedFeatures.benefits.realTimeIndexNow',
		},
	},
	[SECTION_COLLABORATION]: {
		clientAccess: {
			id: 'ui.planBenefits.section.collaboration.benefits.clientAccess',
		},
		cobranding: {
			id: 'ui.planBenefits.section.collaboration.benefits.cobranding',
		},
	},
	[SECTION_CORE_FEATURES]: {
		alerting: {
			id: 'ui.planBenefits.section.coreFeatures.benefits.alerting',
		},
		changeTracking: {
			id: 'ui.planBenefits.section.coreFeatures.benefits.changeTracking',
		},
		nonStopMonitoring: {
			id: 'ui.planBenefits.section.coreFeatures.benefits.nonStopMonitoring',
		},
		rechecks: {
			id: 'ui.planBenefits.section.coreFeatures.benefits.rechecks',
		},
		users: {
			id: 'ui.planBenefits.section.coreFeatures.benefits.users',
		},
		websiteAuditing: {
			id: 'ui.planBenefits.section.coreFeatures.benefits.websiteAuditing',
		},
		websites: {
			id: 'ui.planBenefits.section.coreFeatures.benefits.websites',
		},
	},
	[SECTION_INTEGRATIONS]: {
		adobeAnalytics: {
			id: 'ui.planBenefits.section.integrations.benefits.adobeAnalytics',
		},
		dataEnrichmentAPI: {
			id: 'ui.planBenefits.section.integrations.benefits.dataEnrichmentAPI',
		},
		googleAnalytics: {
			id: 'ui.planBenefits.section.integrations.benefits.googleAnalytics',
		},
		googleChromeExtension: {
			id: 'ui.planBenefits.section.integrations.benefits.googleChromeExtension',
		},
		googleLookerStudio: {
			id: 'ui.planBenefits.section.integrations.benefits.googleLookerStudio',
		},
		googleSearchConsole: {
			id: 'ui.planBenefits.section.integrations.benefits.googleSearchConsole',
		},
		microsoftTeams: {
			id: 'ui.planBenefits.section.integrations.benefits.microsoftTeams',
		},
		reportingAPI: {
			id: 'ui.planBenefits.section.integrations.benefits.reportingAPI',
		},
		slack: {
			id: 'ui.planBenefits.section.integrations.benefits.slack',
		},
	},
	[SECTION_MONITORING_SETTINGS]: {
		customMonitoringLocation: {
			id: 'ui.planBenefits.section.monitoringSettings.benefits.customMonitoringLocation',
		},
		lightspeedMonitoring: {
			id: 'ui.planBenefits.section.monitoringSettings.benefits.lightspeedMonitoring',
		},
		monitoringFromUSUKEU: {
			id: 'ui.planBenefits.section.monitoringSettings.benefits.monitoringFromUSUKEU',
		},
	},
	[SECTION_SERVICES]: {
		chatSupport: {
			id: 'ui.planBenefits.section.services.benefits.chatSupport',
		},
		customTraining: {
			id: 'ui.planBenefits.section.services.benefits.customTraining',
		},
		dedicatedSuccessManager: {
			id: 'ui.planBenefits.section.services.benefits.dedicatedSuccessManager',
		},
		emailSupport: {
			id: 'ui.planBenefits.section.services.benefits.emailSupport',
		},
		guidesAndVideos: {
			id: 'ui.planBenefits.section.services.benefits.guidesAndVideos',
		},
		phoneSupport: {
			id: 'ui.planBenefits.section.services.benefits.phoneSupport',
		},
	},
});



const BenefitName = (props) => {
	const {
		benefit,
		section,
	} = props;

	return (
		<FormattedMessage {...messages[section][benefit]} />
	);
};



export default BenefitName;
